// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4k-1";
export var standaloneTable = "_4k-0";